import * as z from 'zod'
import { Driver } from '~/shared/api'
import { Option, OptionEnum } from '~/shared/config/constants'
import { CountryEnum } from '~/shared/config/countryEnum'

export const formSchema = Driver.schema.pick({
  lastName: true,
  firstName: true,
  middleName: true,
  birthDate: true,
  phone: true,
  ogrnip: true,
  email: true,
  passportIssueDate: true,
  citizenship: true,
  passportNumber: true,
  drivingExperienceStartDate: true,
  drivingLicenseIssuingCountry: true,
  drivingLicenseNumber: true,
  drivingLicenseIssueDate: true,
  drivingLicenseExpirationDate: true,
  placeOfResidence: true,
  data: true,
  comment: true,
  regionId: true,
})

export type SchemaType = z.infer<typeof formSchema>

export type FormValues = Omit<
  SchemaType,
  'regionId' | 'citizenship' | 'drivingLicenseIssuingCountry' | 'email'
> & {
  regionId: UniqueId | Option | null
  citizenship: CountryEnum | OptionEnum<CountryEnum> | null
  drivingLicenseIssuingCountry: CountryEnum | OptionEnum<CountryEnum> | null
  email: string | null | undefined
}
